import React from 'react';
import { useSearchParams } from 'react-router-dom';
import TableSummary from '../../components/TableBeneficiaries/TableSummary';

const BeneficiarySummary = () => {
  const [searchParams] = useSearchParams();

  const beneficiaryCpf = searchParams.get('cpf');

  if (!beneficiaryCpf) return null;

  return (
    <div className="beneficiary-summary-general">
      <TableSummary beneficiaryCpf={beneficiaryCpf} />
    </div>
  );
};

export default BeneficiarySummary;
